import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { PermissionService } from '../authorization/permission';

export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	const permissionService  = inject(PermissionService);
    const router             = inject(Router);
    const requiredPermission = route.data['requiredPermission'] as string;

    if(!requiredPermission) {
        console.warn('PermissionGuard: No se encontró un permiso requerido en los datos de la ruta. Acceso concedido por defecto.', route);

        return true;
    }

    return permissionService.hasPermission(requiredPermission).pipe(take(1), map(hasPerm => {
		if(hasPerm) {
			return true;
		} else {
			return router.createUrlTree(['/dashboard']);
		}
    }));
};
